/**
 * **ダメージ**（Issue #589）。`battle` ＝ 戦闘ダメージ（直前の `battle`。間に `chaining` /
 * `damage_step_end` / フェイズ・ターンの切り替えが挟まればその battle のダメージではない）/ `effect` ＝ 効果ダメージ。
 * 事実: `battle`（攻撃するカード・対象の場所・攻撃したプレイヤー。戦闘ダメージだけ）
 */
export const VARIANTS = Object.freeze([
  { name: 'battle', label: '戦闘ダメージ' },
  { name: 'effect', label: '効果ダメージ' },
]);

const UNTIL = Object.freeze(['chaining', 'damage_step_end', 'new_phase', 'new_turn']);

export default Object.freeze({
  event: 'damage',
  variants: VARIANTS,
  classify({ payload, history }) {
    if (!Number.isFinite(payload?.amount) || payload.amount <= 0) return null;
    const battle = history?.last?.('battle', { until: UNTIL })?.payload ?? null;
    const pick = (c) => (c ? { uid: c.uid ?? null, zone: c.zone ?? null, player: c.player ?? null } : null);
    return {
      ...payload,
      variant: battle ? 'battle' : 'effect',
      isBattle: Boolean(battle),
      battle: battle ? { attacker: pick(battle.attacker), target: pick(battle.target), player: battle.attacker?.player ?? battle.player ?? 0 } : null,
    };
  },
});
